import styled from 'styled-components'

export const ContainerMenuItem = styled.div<{ $selectedItem: boolean }>`
  background-color: ${({ $selectedItem }) => ($selectedItem ? 'var(--gray-200)' : 'none')};
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: var(--gray-200);
    cursor: pointer;
  }
`

export const Title = styled.p`
  width: max-content;
`
